import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iposcen-ipos-help-regional-hq',
  templateUrl: './ipos-help-regional-hq.component.html',
  styleUrls: ['./ipos-help-regional-hq.component.scss']
})
export class IposHelpRegionalHqComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
